import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  unitRow: {
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#FAFAFA',
    },
  },
  TableCell: {
    ...theme.tables.tableCell,
    padding: '10px 15px',
    verticalAlign: 'top',
  },
  emptyCell: {
    ...theme.tables.tableCell,
    padding: '10px 15px',
    borderBottom: '1px solid #f0f0f0',
  },
  arrowPlaceholder: {
    ...theme.tables.tableCell,
    padding: '0 5px',
    width: 40,
    borderBottom: '1px solid #f0f0f0',
  },
  mediumWidth: {
    width: '200px !important',
    maxWidth: '200px !important',
  },
  selectTrigger: {
    width: '130px !important',
  },
  inputRoot: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    height: '25px',
    fontSize: '14px',
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    paddingRight: '50px',
  },
  textOverflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'calc(100% - 25px)',
  },
  statusCell: {
    fontWeight: 500,
  },
  highlight: {
    background: '#EDEBED',
  },
  appUnitNameCell: {
    minWidth: '180px',
  },
  viewContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '4px',
  },
  titleText: {
    fontSize: '13px',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  editIcon: {
    padding: 2,
    flexShrink: 0,
    '& svg': {
      fontSize: 14,
      color: '#545964',
    },
  },
  editContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '2px',
  },
  editInput: {
    fontSize: '13px',
    padding: '4px 8px',
  },
  editAction: {
    padding: 2,
    flexShrink: 0,
  },
  menuItemWithLine: {
    padding: '0 16px',
    height: '1px',
    minHeight: '1px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:active': {
      backgroundColor: 'transparent',
    },
  }
}));

export default useStyles;
